import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { addPageAction } from '@nike/ux-tread-new-relic';
import initializeUser from './initialize-user';
function initializeWebShellIdentity(_x) {
  return _initializeWebShellIdentity.apply(this, arguments);
}
function _initializeWebShellIdentity() {
  _initializeWebShellIdentity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var startTime, _window, userProfile, userType, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          startTime = _ref.startTime;
          _context.prev = 1;
          _context.next = 2;
          return (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 ? void 0 : _window.identity.getUserProfile();
        case 2:
          userProfile = _context.sent;
          userType = userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType;
          addPageAction('nike-shop-shell-identity-event', {
            version: window.NikeShop.version,
            loadTime: Date.now() - startTime,
            status: 'Initialized',
            userType: userType
          });
          initializeUser();
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          addPageAction('nike-shop-shell-identity-failure', {
            version: window.NikeShop.version
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _initializeWebShellIdentity.apply(this, arguments);
}
export default initializeWebShellIdentity;